/**
 * Formats cents to BRL currency string.
 *
 * @param {number|null|undefined} cents - Value in cents
 * @returns {string} Formatted BRL string (e.g. "R$ 1.884,00")
 */
export function formatBRL(cents) {
  if (cents === null || cents === undefined) {
    return "R$ 0,00";
  }

  const value = cents / 100;

  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

/**
 * Converts BRL value (number or string) to cents.
 *
 * @param {number|string} value - Value in reais (e.g. 1951.22, "1951,22", "1951.22")
 * @returns {number} Value in cents
 */
export function toCents(value) {
  if (value === null || value === undefined || value === "") {
    return 0;
  }

  let numValue;

  if (typeof value === "string") {
    const cleaned = value
      .replace(/R\$\s?/g, "")
      .replace(/\./g, "")
      .replace(",", ".")
      .trim();

    numValue = parseFloat(cleaned);
  } else {
    numValue = Number(value);
  }

  if (isNaN(numValue)) {
    return 0;
  }

  return Math.round(numValue * 100);
}
